import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/newsletter";

class NewsletterService {
  createNewsletter = async ({ email, preferences }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, {
        email,
        preferences,
      });
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while creating newsletter, status:" + err.code
      );
    }
  };
  getNewsletters = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching newsletters, status:" + err.code
      );
    }
  };

  deleteNewsletter = async (newsletterId) => {
    try {
      const response = await axiosApiClient.delete(
        `${BASE_URL}/${newsletterId}`
      );
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting newsletter.");
    }
  };

  sendEmails = async ({ emailIds, subject, htmlContent }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/send-emails`, {
        emailIds,
        subject,
        htmlContent,
      });
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while sending emails, status:" + err.code
      );
    }
  };
}

const newsletterService = new NewsletterService();

export default newsletterService;
